import * as React from 'react'

import { PublicUserInfo } from '../../sdk/model';
import { Box, Autocomplete, TextField, Typography, Avatar, Button } from '@mui/material';
import { userApi } from '../../adapters/APIExporter'

const getOwnerDisplayName = (owner: PublicUserInfo): string => {
  if (!owner) return 'Owner';
  // Use type assertion to access potential properties
  const ownerAny = owner as any;
  return ownerAny.displayName || ownerAny.username || ownerAny.email || 'Owner';
};

const getOwnerPicture = (owner: PublicUserInfo): string | undefined => {
  if (!owner) return undefined;
  // Use type assertion to access potential picture property
  return (owner as any).picture || undefined;
};

interface SearchUserProps {
  omittedUsers: string[],
  selectUser: Function,
}

function SearchUser(searchUserProps: SearchUserProps) {
  const [searchQuery, setSearchQuery] = React.useState("");
  const [potentialMatches, setPotentialMatches] = React.useState<PublicUserInfo[]>([]);
  
  function queryUser(event) {
    const newSearchQuery = event.target.value;
    setSearchQuery(newSearchQuery);
    if (newSearchQuery.length >= 3) {
      userApi.queryUsers(newSearchQuery, searchUserProps.omittedUsers).then(result => {
        setPotentialMatches(result.data);
      });
    } else {
      setPotentialMatches([]);
    }
  }
  
  return <Box>
    <Autocomplete
      disablePortal
      freeSolo
      options={potentialMatches}
      getOptionLabel={(option) => option.username!}
      renderOption={(props, option) => {
        return <Button {...props} onClick={() => {
          searchUserProps.selectUser(option);
          setSearchQuery("");
          setPotentialMatches([]);
        }}>
            <Typography variant="body2">
              {getOwnerDisplayName(option)}
            </Typography>
            {getOwnerPicture(option) && (
              <Avatar 
                src={getOwnerPicture(option)} 
                sx={{ width: 24, height: 24 }}
              />
            )}
          </Button>
      }}
      sx={{ width: 300 }}
      renderInput={(params) => <TextField {...params} name='username' label="Find User" value={searchQuery} onChange={queryUser} />}
    />
    
  </Box>
}

export default SearchUser;
